import styled from "styled-components";
import { MdExpandMore } from "react-icons/md";
export const Container = styled.div`
    min-height:300px;
    height: auto;
    display: grid;
    grid-template-columns: 20% 80%;
    grid-gap: 10px;
    width:94.2%
`
export const CardContainer = styled.div`
 border:2px solid #f2f2f2;
 border-radius: 10px;
 width:90%;
 min-height: 55px;
 height: auto;
 text-align: center;
 font-weight: 500;
 margin-bottom:  10px;
`
export const CMdExpandMore = styled(MdExpandMore)`
    margin: 10px;
    margin: 15px 10px 10px 10px;

`
export const CardTitle = styled.div`
float: left;
margin: 15px 10px 10px 25px;
`

export const MedicalCard = styled.div`
border:1px solid #f2f2f2;
width: 100%;
min-height: 300px;
height: auto;
margin: auto;
border-radius:10px;
overflow:auto;
background-color:white;
`
export const MedicalSearch = styled.div`
 display: flex;
 flex-wrap: wrap;
 padding:15px 25px 15px 25px;
 width:100%;
`
export const MedicalTab = styled.div`
display: flex;
align-items: center;
background-color: #4678eb;
height: 35px;
width: 100%;
color: white;
font-weight: 600;
font-size:12px;
padding-left:27px;
font-weight:600;
font-family: Montserrat, 'Open Sans', Helvetica, Arial, sans-serif;
`
export const Table = styled.table`
    font-size: 14px;
    width: 100%;
    overflow:auto;
    th{
        font-size:12px;
        text-align: left;
        padding-top:15px;
        padding-left:27px;
        font-weight:600;
        color:#58595B;
font-family: Montserrat SemiBold, 'Open Sans', Helvetica, Arial, sans-serif;
    }
    td{
        text-align: left;
        color:grey;
        font-size:12px;
        font-weight:500;
        font-family: Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif;
        padding-top:15px;
        color:#969696;
        padding-left:27px;
    }
`

export const ADHImage = styled.img`
width:130px;
height:500px;
@media (max-width:1416px){
    width:130px;
  }
@media (max-width:1116px){
  width:110px;
}
@media (max-width:766px){
  width:90px;
}
@media (max-width:640px){
  width:85px;
}
`